"use client";

import { useEffect } from "react";

/** Slide-up on scroll: adds `.is-visible` to `.cxo-reveal` / `.cxo-stagger` once in view. */
export default function CxoReveal() {
  useEffect(() => {
    const els = document.querySelectorAll<HTMLElement>(".cxo-reveal, .cxo-stagger");

    if (typeof IntersectionObserver === "undefined") {
      els.forEach((el) => el.classList.add("is-visible"));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );

    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return null;
}
